import { surveyLocalization } from "../surveyStrings";

export var finnishSurveyStrings = {
  pagePrevText: "Edellinen",
  pageNextText: "Seuraava",
  completeText: "Valmis",
  previewText: "Esikatselu",
  editText: "Muokata",
  startSurveyText: "alkaa",
  otherItemText: "Muu (kuvaile)",
  noneItemText: "Ei mitään",
  selectAllItemText: "Valitse kaikki",
  progressText: "Sivu {0}/{1}",
  panelDynamicProgressText: "Nauhoita {0} / {1}",
  questionsProgressText: "Vastasi kysymyksiin {0} / {1}",
  emptySurvey:
    "Tässä kyselyssä ei ole yhtäkään näkyvillä olevaa sivua tai kysymystä.",
  completingSurvey: "Kiitos kyselyyn vastaamisesta!",
  completingSurveyBefore:
    "Tietojemme mukaan olet jo suorittanut tämän kyselyn.",
  loadingSurvey: "Kyselyä ladataan palvelimelta...",
  optionsCaption: "Valitse...",
  value: "arvo",
  requiredError: "Vastaa kysymykseen, kiitos.",
  requiredErrorInPanel: "Vastaa ainakin yhteen kysymykseen.",
  requiredInAllRowsError: "Vastaa kysymyksiin kaikilla riveillä.",
  numericError: "Arvon tulee olla numeerinen.",
  textMinLength: "Ole hyvä ja syötä vähintään {0} merkkiä.",
  textMaxLength: "Anna alle {0} merkkiä.",
  textMinMaxLength: "Anna yli {0} ja alle {1} merkkiä.",
  minRowCountError: "Täytä vähintään {0} riviä.",
  minSelectError: "Ole hyvä ja valitse vähintään {0} vaihtoehtoa.",
  maxSelectError: "Ole hyvä ja valitse enintään {0} vaihtoehtoa.",
  numericMinMax:
    "'{0}' täytyy olla enemmän tai yhtä suuri kuin {1} ja vähemmän tai yhtä suuri kuin {2}",
  numericMin: "'{0}' täytyy olla enemmän tai yhtä suuri kuin {1}",
  numericMax: "'{0}' täytyy olla vähemmän tai yhtä suuri kuin {1}",
  invalidEmail: "Syötä validi sähköpostiosoite.",
  invalidExpression: "Lausekkeen: {0} pitäisi palauttaa 'true'.",
  urlRequestError: "Pyyntö palautti virheen {0}. {1}",
  urlGetChoicesError:
    "Pyyntö palautti tyhjät tiedot tai polku-ominaisuus on väärä",
  exceedMaxSize: "Tiedoston koko ei saa olla suurempi kuin {0}.",
  otherRequiredError: "Anna toinen arvo.",
  uploadingFile:
    "Tiedostoa ladataan. Odota muutama sekunti ja yritä uudelleen.",
  loadingFile: "Ladataan...",
  chooseFile: "Valitse tiedosto (t) ...",
  noFileChosen: "Ei tiedostoa valittuna",
  confirmDelete: "Haluatko poistaa tietueen?",
  keyDuplicationError: "Tämän arvon tulisi olla ainutlaatuinen.",
  addColumn: "Lisää sarake",
  addRow: "Lisää rivi",
  removeRow: "Poista",
  addPanel: "Lisää uusi",
  removePanel: "Poista",
  choices_Item: "kohde",
  matrix_column: "Sarake",
  matrix_row: "Rivi",
  savingData: "Tulokset tallennetaan palvelimelle ...",
  savingDataError: "Tapahtui virhe, emmekä voineet tallentaa tuloksia.",
  savingDataSuccess: "Tulokset tallennettiin onnistuneesti!",
  saveAgainButton: "Yritä uudelleen",
  timerMin: "min",
  timerSec: "sek",
  timerSpentAll: "Olet käyttänyt {0} tällä sivulla ja yhteensä {1}.",
  timerSpentPage: "Olet viettänyt {0} tällä sivulla.",
  timerSpentSurvey: "Olet käyttänyt yhteensä {0}.",
  timerLimitAll:
    "Olet käyttänyt tällä sivulla {0} / {1} ja yhteensä {2} / {3}.",
  timerLimitPage: "Olet käyttänyt {0} / {1} tällä sivulla.",
  timerLimitSurvey: "Olet käyttänyt yhteensä {0} / {1}.",
  cleanCaption: "Puhdas",
  clearCaption: "Asia selvä",
  chooseFileCaption: "Valitse tiedosto",
  removeFileCaption: "Poista tämä tiedosto",
  booleanCheckedLabel: "Joo",
  booleanUncheckedLabel: "Ei",
  confirmRemoveFile: "Haluatko varmasti poistaa tämän tiedoston: {0}?",
  confirmRemoveAllFiles: "Haluatko varmasti poistaa kaikki tiedostot?",
  questionTitlePatternText: "Kysymyksen otsikko",
};

surveyLocalization.locales["fi"] = finnishSurveyStrings;
surveyLocalization.localeNames["fi"] = "suomalainen";



// WEBPACK FOOTER //
// ./src/localization/finnish.ts